import { from, Device } from '@helpers/media';
import styled from 'styled-components';
import CtaLinkStyles from '../CtaLink/CtaLink.styles';
import { transition } from '@helpers/animate';
const Container = styled.div ``;
const ReadMore = styled.div `
  opacity: 1;
  width: 100%;
  margin: 0 0 22px;

  ${CtaLinkStyles.Container}[data-has-arrow='false'] {
    svg {
      ${transition('transform')};

      width: 12px;
    }

    &:focus-visible,
    &:hover {
      svg {
        transform: translateY(3px);
      }
    }
  }

  &[data-expanded='true'] {
    ${CtaLinkStyles.Container}[data-has-arrow='false'] {
      svg {
        ${transition('transform')};

        transform: rotate(180deg);
      }

      &:focus-visible,
      &:hover {
        svg {
          transform: rotate(180deg) translateY(3px);
        }
      }
    }
  }

  @media ${from(Device.TabletLarge)} {
    display: none;
  }
`;
export const ReadMoreStyles = {
    Container,
    ReadMore,
};
